<script lang="ts" setup>
import SkrButton from '@/components/button/SkrButton.vue'
import CardWithIcon from '@/components/dashboard/CardWithIcon.vue'
import BaseDialog from '@/components/dialogs/BaseDialog.vue'

defineProps<{
  loading: boolean
}>()

const emit = defineEmits<{
  action: [data: Dialogs['business/DialogBusinessDowngraded']['contextData']]
}>()

const { t } = useI18n()
const { mdAndUp } = useDisplay()

const isLegalAccepted = ref<boolean>(false)
</script>

<template>
  <base-dialog :title="t('dialog.member_migrated_to_starter.title')" persistent max-width="796">
    <v-row class="my-6">
      <v-col class="justify-space-between d-flex flex-column" cols="12" md="7">
        <div>
          <p class="text-h5 text-skribbleu font-weight-bold pb-6">
            {{ t('dialog.member_migrated_to_starter.subtitle') }}
          </p>

          <p class="pb-4 text-pre-wrap">
            {{ t('dialog.member_migrated_to_starter.text') }}
          </p>
        </div>
        <div>
          <skr-checkbox v-model="isLegalAccepted" class="pb-8">
            <i18n-t keypath="global.accept_gtc.label_text" tag="div" for="global.accept_gtc.label_link_text">
              <a :href="t('global.accept_gtc.link_url')" target="_blank" rel="noopener" @click.stop>{{
                t('global.accept_gtc.label_link_text')
              }}</a>
            </i18n-t>
          </skr-checkbox>
          <skr-button
            class="mt-auto"
            size="xl"
            block
            :loading="loading"
            :disabled="loading || !isLegalAccepted"
            @click="() => emit('action', {})"
          >
            {{ t('dialog.member_migrated_to_starter.action') }}
          </skr-button>
        </div>
      </v-col>
      <v-col v-if="mdAndUp" class="justify-items-center" cols="12" md="5">
        <div class="cards">
          <card-with-icon
            :icon-size="115"
            class="card__free"
            icon="custom:free_to_sign"
            bg-color="purple-light"
            color="purple-dark"
          >
            <p class="card__text">
              <span class="font-weight-bold">{{ t('home.welcome_starter.card_free.part_1') }}</span>
              {{ t('home.welcome_starter.card_free.part_2') }}
            </p>
          </card-with-icon>
          <card-with-icon
            :icon-size="115"
            class="card__pay"
            icon="custom:pay_to_sign"
            bg-color="grey-bg-7"
            color="skribbleu"
          >
            <p class="card__text">
              <span class="font-weight-bold">{{ t('home.welcome_starter.card_pay_per_use.part_1') }}</span>
              {{ t('home.welcome_starter.card_pay_per_use.part_2') }}
            </p>
          </card-with-icon>
        </div>
      </v-col>
    </v-row>
    <template #actions>
      <v-spacer />
    </template>
  </base-dialog>
</template>

<style lang="scss" scoped>
.cards {
  margin-top: 7 * $bw;
  max-width: 200px;
  align-items: left;
  .card {
    padding-left: 8 * $bw;
    padding-right: 4 * $bw;
    &__text {
      font-size: 18px;
    }
    &__pay {
      color: $c-skribbleu;
      margin-top: 11 * $bw;
    }
    &__free {
      color: $c-purple-dark;
    }
  }
}
</style>
